import React from "react";
import { observer } from "mobx-react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Button,
} from "@mui/material";

// Reusable read-only modal for drilldown to a referenced entity's view.
// Wraps a MUI Dialog and renders whatever the caller passes as children
// (typically <${Entity}View ${entity}ViewStore={...}/>). Caller manages
// the store lifecycle and the open/close state — Dialog stays dumb so it
// works for both live entities (caller instantiates ViewStore and loads
// via API) and snapshot entities (caller passes a pre-built adapter).
type EntityViewDialogProps = {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
};

export const EntityViewDialog: React.FC<EntityViewDialogProps> = observer(
  ({ open, onClose, title, children }) => {
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);
